import { Alert, AlertTitle, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function RuuviTagInstallationInfoAlert() {
  /**
   * The translate function.
   */
  const { t } = useTranslation('ruuvitag')

  return (
    <Alert severity="info">
      <AlertTitle sx={{ m: 0 }}>{t('RuuviTagInstallationInfoAlert.title')}</AlertTitle>
      <List>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
          <ListItemText primary={t('RuuviTagInstallationInfoAlert.stepOne')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
          <ListItemText primary={t('RuuviTagInstallationInfoAlert.stepTwo')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
          <ListItemText primary={t('RuuviTagInstallationInfoAlert.stepThree')} />
        </ListItem>
      </List>
    </Alert>
  )
}
